import React, { useEffect, createElement, Component } from 'react';
import { Shield, Check, ArrowRight } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQ } from './components/FAQ';
const CHECKOUT_URL = 'https://checkout.larutadelconocimiento.com/cart/43949036175469:1';
const NEW_MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/grB8hnyfftfwEKECY9VrB8/Diseno_sin_titulo_(1).png';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '1375239330854800');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  const scrollToCheckout = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-gray-50 min-h-screen pb-8" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* 1. URGENCY HEADER BAR - Centered with countdown */}
      <div className="bg-red-600 text-white py-0.5 px-2 sticky top-0 z-40" data-id="element-2">
        <div className="max-w-6xl mx-auto flex items-center justify-center text-center" data-id="element-3">
          <div className="flex items-center space-x-1" data-id="element-4">
            <span className="font-bold uppercase text-[10px]" data-id="element-5">
              ⏳ OFERTA EXPIRA EN:
            </span>
            <CountdownTimer data-id="element-6" />
          </div>
        </div>
      </div>

      {/* 2. HERO SECTION - Reduced spacing */}
      <header className="bg-white pt-4 pb-6 px-4 border-b-4 border-blue-900" data-id="element-7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-8">
          <p className="text-blue-600 font-medium tracking-wide uppercase mb-2 text-xs" data-id="element-9">
            🧠🎨 Para terapeutas, psicólogos/as, AT, coaches y profesionales del
            bienestar
          </p>

          <h1 className="text-2xl md:text-4xl font-extrabold text-gray-900 leading-tight mb-3" data-id="element-10">
            MegaPack <span className="text-blue-600" data-id="element-11">Arteterapia Clínica</span>
          </h1>

          <p className="text-base md:text-lg text-gray-600 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-12">
            El sistema profesional para aplicar arteterapia en sesiones reales,{' '}
            <span className="font-bold text-gray-900 bg-yellow-100 px-1" data-id="element-13">
              sin improvisar
            </span>{' '}
            y con recursos listos para usar.
          </p>

          <div className="mb-4 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-14">
            <img src={NEW_MAIN_IMAGE} alt="MegaPack Arteterapia Clínica Completo" className="mx-auto w-full max-w-md drop-shadow-xl cursor-pointer" onClick={scrollToCheckout} data-id="element-15" />
          </div>

          <button onClick={scrollToCheckout} className="inline-flex items-center justify-center w-full md:w-auto px-6 py-4 text-xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-16">
            <span className="w-full text-center" data-id="element-17">
              👉 SÍ, QUIERO ACCEDER AHORA
            </span>
          </button>

          <div className="mt-2 flex items-center justify-center text-xs text-gray-500 font-medium" data-id="element-18">
            <Shield className="w-3 h-3 mr-1 text-green-600" data-id="element-19" />✅ Garantía de
            satisfacción de 7 días
          </div>
        </div>
      </header>

      {/* 3. PAIN POINTS - Reduced spacing */}
      <section className="py-8 px-4 bg-gray-50" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-gray-900" data-id="element-22">
            Si trabajás con pacientes, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white p-6 rounded-xl shadow-sm border-l-8 border-red-500" data-id="element-23">
            <p className="text-lg font-semibold mb-4 text-gray-800" data-id="element-24">
              ¿Te pasa que preparar la sesión te cansa más que la sesión misma?
            </p>

            <p className="mb-4 text-gray-600 text-sm" data-id="element-25">
              No porque no sepas. No porque te falte intuición o sensibilidad
              clínica. Sino porque cuando querés aplicar arteterapia en serio
              aparecen problemas reales:
            </p>

            <ul className="space-y-2" data-id="element-26">
              {['No sabés qué técnica elegir en el momento exacto', 'Preparar materiales te lleva más tiempo que la sesión', 'Dudás cuando el paciente se bloquea / se desborda / se activa', 'Tenés recursos, pero no tenés estructura clínica clara', 'Terminás improvisando o usando siempre lo mismo "por seguridad"'].map((item, i) => <li key={i} className="flex items-start" data-id="element-27">
                  <div className="bg-red-100 p-1 rounded-full mr-2 mt-0.5 flex-shrink-0" data-id="element-28">
                    <XIcon className="w-3 h-3 text-red-600" data-id="element-29" />
                  </div>
                  <span className="text-gray-700 text-sm" data-id="element-30">{item}</span>
                </li>)}
            </ul>

            <p className="mt-4 text-gray-800 font-bold italic border-t pt-3 text-sm" data-id="element-31">
              Y cuando empieza la sesión… ya llegás desgastado/a.
            </p>
          </div>
        </div>
      </section>

      {/* 4. PROBLEM SECTION - Reduced spacing */}
      <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-32">
        <div className="max-w-3xl mx-auto text-center" data-id="element-33">
          <h2 className="text-2xl font-bold mb-4 text-red-400" data-id="element-34">
            El problema que nadie dice en voz alta
          </h2>
          <p className="text-lg mb-6 leading-relaxed" data-id="element-35">
            Si sos profesional y querés integrar arteterapia, esto suele pasar:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left" data-id="element-36">
            {['Tenés formación o nociones, pero no un sistema aplicable', 'Guardás recursos sueltos, pero están desordenados', 'Buscás técnicas en mil lugares y perdés tiempo', 'Te da miedo intervenir mal y "empeorar" el momento', 'Improvisás más de lo que te gustaría'].map((item, i) => <div key={i} className="flex items-center bg-gray-800 p-3 rounded-lg border border-gray-700 text-sm" data-id="element-37">
                <div className="w-2 h-2 bg-red-500 rounded-full mr-2" data-id="element-38"></div>
                <span data-id="element-39">{item}</span>
              </div>)}
          </div>

          <p className="mt-6 text-xl font-light italic text-gray-300" data-id="element-40">
            Y queda esa sensación constante de: <br data-id="element-41" />
            <span className="text-white font-bold" data-id="element-42">
              "Podría sostener mejor la sesión… si tuviera todo listo."
            </span>
          </p>
        </div>
      </section>

      {/* 5. SOLUTION INTRO - Reduced spacing */}
      <section className="py-10 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-43">
        <div className="max-w-4xl mx-auto text-center" data-id="element-44">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-3 py-1 rounded-full mb-4 text-sm" data-id="element-45">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900 mb-4" data-id="element-46">
            MegaPack Arteterapia Clínica
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-47">
            Un sistema completo, estructurado y profesional para intervenir con
            arteterapia en sesiones reales con seguridad, claridad y recursos
            concretos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-48">
            {[{
            icon: '📂',
            title: 'Abrís el material'
          }, {
            icon: '👆',
            title: 'Elegís objetivo / técnica'
          }, {
            icon: '✍️',
            title: 'Lo aplicás en sesión'
          }].map((step, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-lg border-b-4 border-blue-500" data-id="element-49">
                <div className="text-4xl mb-2" data-id="element-50">{step.icon}</div>
                <h3 className="text-lg font-bold text-gray-900" data-id="element-51">
                  {step.title}
                </h3>
              </div>)}
          </div>

          <p className="text-xl font-bold text-gray-800 mb-6" data-id="element-52">
            Sin vueltas. Sin improvisar. Sin perder tiempo.
          </p>

          <button onClick={scrollToCheckout} className="inline-block px-6 py-3 text-lg font-bold text-white bg-green-600 rounded-full shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200" data-id="element-53">
            <span className="w-full text-center" data-id="element-54">
              QUIERO MI SISTEMA DE ARTETERAPIA
            </span>
          </button>
        </div>
      </section>

      {/* 6. PRODUCT DETAILS - Reduced spacing */}
      <section className="py-10 px-4 bg-white" data-id="element-55">
        <div className="max-w-5xl mx-auto" data-id="element-56">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 text-gray-900" data-id="element-57">
            📘 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="space-y-10" data-id="element-58">
            {/* Component 1 */}
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-59">
              <div className="flex-1" data-id="element-60">
                <h3 className="text-xl font-bold text-blue-800 mb-3 flex items-center" data-id="element-61">
                  <span className="bg-blue-100 text-blue-800 p-2 rounded-lg mr-2" data-id="element-62">
                    ✅
                  </span>
                  6 Tomos de Arteterapia Clínica
                </h3>
                <p className="text-gray-700 mb-3 text-sm" data-id="element-63">
                  Más de 100 técnicas listas para aplicar, organizadas por
                  objetivos terapéuticos:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4" data-id="element-64">
                  {['Dibujo terapéutico', 'Collage y técnicas proyectivas', 'Mapas emocionales y corporales', 'Trabajo simbólico', 'Regulación emocional', 'Integración y cierre de procesos'].map((item, i) => <div key={i} className="flex items-center text-xs font-medium text-gray-600" data-id="element-65">
                      <Check className="w-3 h-3 text-green-500 mr-1 flex-shrink-0" data-id="element-66" />
                      {item}
                    </div>)}
                </div>
                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-67">
                  <p className="font-bold text-gray-900 mb-1 text-sm" data-id="element-68">
                    Cada técnica incluye:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-0.5 text-xs" data-id="element-69">
                    <li data-id="element-70">Propósito terapéutico</li>
                    <li data-id="element-71">Cómo aplicarla en sesión</li>
                    <li data-id="element-72">Variantes según edad y nivel</li>
                    <li data-id="element-73">Enfoque clínico claro</li>
                  </ul>
                </div>
                <p className="mt-3 font-bold text-blue-600 text-sm" data-id="element-74">
                  👉 Abrís el tomo, elegís y aplicás.
                </p>
              </div>
              <div className="w-full md:w-1/3" data-id="element-75">
                <img src={NEW_MAIN_IMAGE} alt="Tomos" className="rounded-lg shadow-xl" data-id="element-76" />
              </div>
            </div>

            <hr className="border-gray-100" data-id="element-77" />

            {/* Component 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-6" data-id="element-78">
              <div className="flex-1" data-id="element-79">
                <h3 className="text-xl font-bold text-purple-800 mb-3 flex items-center" data-id="element-80">
                  <span className="bg-purple-100 text-purple-800 p-2 rounded-lg mr-2" data-id="element-81">
                    🃏
                  </span>
                  Baraja Emocional Terapéutica (52 cartas)
                </h3>
                <p className="font-bold text-gray-900 mb-2 text-sm" data-id="element-82">Para:</p>
                <ul className="space-y-1 mb-4" data-id="element-83">
                  {['Desbloquear procesos', 'Trabajar emociones difíciles sin confrontar', 'Facilitar expresión cuando no hay palabras', 'Iniciar o cerrar sesiones con sentido clínico'].map((item, i) => <li key={i} className="flex items-start" data-id="element-84">
                      <div className="w-1.5 h-1.5 bg-purple-500 rounded-full mr-2 mt-1.5" data-id="element-85"></div>
                      <span className="text-gray-700 text-sm" data-id="element-86">{item}</span>
                    </li>)}
                </ul>
                <div className="flex flex-wrap gap-1" data-id="element-87">
                  {['52 cartas emocionales y simbólicas', 'Individual o grupal', 'Niños, adolescentes y adultos', 'Digital e imprimible'].map((tag, i) => <span key={i} className="bg-purple-50 text-purple-700 px-2 py-0.5 rounded-full text-xs font-bold border border-purple-100" data-id="element-88">
                      ✔️ {tag}
                    </span>)}
                </div>
              </div>
              <div className="w-full md:w-1/3 bg-purple-50 p-4 rounded-xl flex items-center justify-center" data-id="element-89">
                <div className="text-center" data-id="element-90">
                  <span className="text-5xl" data-id="element-91">🃏</span>
                  <p className="font-bold text-purple-900 mt-1 text-sm" data-id="element-92">
                    52 Cartas
                  </p>
                </div>
              </div>
            </div>

            <hr className="border-gray-100" data-id="element-93" />

            {/* Component 3 */}
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-94">
              <div className="flex-1" data-id="element-95">
                <h3 className="text-xl font-bold text-orange-800 mb-3 flex items-center" data-id="element-96">
                  <span className="bg-orange-100 text-orange-800 p-2 rounded-lg mr-2" data-id="element-97">
                    📒
                  </span>
                  Cuaderno Creativo Terapéutico (Producto Core)
                </h3>
                <p className="text-lg font-bold text-gray-900 mb-3" data-id="element-98">
                  No es un cuaderno para leer. 👉{' '}
                  <span className="text-orange-600" data-id="element-99">
                    Es un cuaderno para intervenir en sesión.
                  </span>
                </p>
                <div className="bg-orange-50 p-4 rounded-xl border border-orange-100" data-id="element-100">
                  <p className="font-bold text-gray-900 mb-2 text-sm" data-id="element-101">
                    Incluye:
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-102">
                    {['Estructuras visuales', 'Espacios de dibujo / collage / símbolos', 'Mapas emocionales', 'Integración y cierre'].map((item, i) => <div key={i} className="flex items-center text-gray-700 text-sm" data-id="element-103">
                        <Check className="w-3 h-3 text-orange-500 mr-1" data-id="element-104" />
                        {item}
                      </div>)}
                  </div>
                </div>
                <p className="mt-3 text-gray-600 italic text-sm" data-id="element-105">
                  Funciona presencial u online.
                </p>
              </div>
              <div className="w-full md:w-1/3 bg-orange-50 p-4 rounded-xl flex items-center justify-center" data-id="element-106">
                <div className="text-center" data-id="element-107">
                  <span className="text-5xl" data-id="element-108">📒</span>
                  <p className="font-bold text-orange-900 mt-1 text-sm" data-id="element-109">
                    Cuaderno Práctico
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-110">
            <button onClick={scrollToCheckout} className="inline-flex items-center justify-center px-6 py-3 text-lg font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 transition-colors" data-id="element-111">
              <span className="text-center" data-id="element-112">👉 ACCEDER CON DESCUENTO</span>
              <ArrowRight className="ml-2 w-4 h-4" data-id="element-113" />
            </button>
          </div>
        </div>
      </section>

      {/* 7. BEFORE / AFTER - Reduced spacing */}
      <section className="py-10 px-4 bg-gray-100" data-id="element-114">
        <div className="max-w-4xl mx-auto" data-id="element-115">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-900" data-id="element-116">
            🔄 Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-6" data-id="element-117">
            {/* Before */}
            <div className="bg-white p-6 rounded-t-xl md:rounded-xl shadow-sm border-t-4 border-red-500 mb-2 md:mb-0" data-id="element-118">
              <h3 className="text-lg font-bold text-red-600 mb-4 flex items-center" data-id="element-119">
                <XIcon className="w-5 h-5 mr-2" data-id="element-120" />
                Antes del MegaPack
              </h3>
              <ul className="space-y-2" data-id="element-121">
                {['Dudas en sesión', 'Improvisación constante', 'Preparación eterna', 'Recursos sueltos', 'Estrés ante bloqueos/emergencias emocionales'].map((item, i) => <li key={i} className="flex items-start text-gray-600 text-sm" data-id="element-122">
                    <span className="text-red-400 mr-2" data-id="element-123">•</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-white p-6 rounded-b-xl md:rounded-xl shadow-lg border-t-4 border-green-500 transform md:scale-105 z-10" data-id="element-124">
              <h3 className="text-lg font-bold text-green-600 mb-4 flex items-center" data-id="element-125">
                <Check className="w-5 h-5 mr-2" data-id="element-126" />
                Después del MegaPack
              </h3>
              <ul className="space-y-2" data-id="element-127">
                {['Intervenciones claras y seguras', 'Técnicas listas siempre', 'Más profundidad terapéutica', 'Menos trabajo fuera de sesión', 'Tranquilidad profesional real'].map((item, i) => <li key={i} className="flex items-start font-medium text-gray-800 text-sm" data-id="element-128">
                    <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" data-id="element-129" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. BONUSES - Reduced spacing */}
      <section className="py-12 px-4 bg-blue-900 text-white" data-id="element-130">
        <div className="max-w-6xl mx-auto" data-id="element-131">
          <div className="text-center mb-10" data-id="element-132">
            <span className="bg-yellow-400 text-blue-900 font-bold px-3 py-1 rounded-full uppercase tracking-wider text-xs" data-id="element-133">
              🎁 Regalos especiales
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-2" data-id="element-134">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-lg text-blue-200" data-id="element-135">(Sin costo adicional)</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-136">
            {/* Bonus 1 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300" data-id="element-137">
              <div className="relative aspect-square bg-gray-100" data-id="element-138">
                <img src="https://cdn.magicpatterns.com/uploads/d3jdW2RHLNFgQFqiWjZH3U/ChatGPT_Image_4_feb_2026,_08_07_28_a.m..png" alt="Bono 1 Workbook" className="w-full h-full object-cover" data-id="element-139" />
                <div className="absolute top-3 right-3 bg-red-600 text-white font-bold px-2 py-0.5 rounded shadow-lg transform rotate-3 text-xs" data-id="element-140">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-4" data-id="element-141">
                <p className="text-xs text-gray-500 line-through mb-0.5" data-id="element-142">
                  Valor: ARS $19.990
                </p>
                <p className="text-green-600 font-bold mb-2 text-sm" data-id="element-143">
                  HOY: GRATIS
                </p>
                <h3 className="text-lg font-bold mb-1" data-id="element-144">
                  🎁 Bono #1 – Workbook Clínico Profesional
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-145">
                  Registro y seguimiento terapéutico: observaciones, evolución,
                  planificación y continuidad clínica.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300" data-id="element-146">
              <div className="relative aspect-square bg-gray-100" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/9r1JSZsf8LevNyVAH4JwcW/ChatGPT_Image_4_feb_2026,_08_09_11_a.m..png" alt="Bono 2 Protocolos" className="w-full h-full object-cover" data-id="element-148" />
                <div className="absolute top-3 right-3 bg-red-600 text-white font-bold px-2 py-0.5 rounded shadow-lg transform rotate-3 text-xs" data-id="element-149">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-4" data-id="element-150">
                <p className="text-xs text-gray-500 line-through mb-0.5" data-id="element-151">
                  Valor: ARS $15.990
                </p>
                <p className="text-green-600 font-bold mb-2 text-sm" data-id="element-152">
                  HOY: GRATIS
                </p>
                <h3 className="text-lg font-bold mb-1" data-id="element-153">
                  🎁 Bono #2 – Banco de Protocolos Clínicos Rápidos
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-154">
                  Protocolos armados (15 / 30 / 50 min): objetivo, técnica
                  principal, regulación, preguntas, cierre y error a evitar.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300" data-id="element-155">
              <div className="relative aspect-square bg-gray-100" data-id="element-156">
                <img src="https://cdn.magicpatterns.com/uploads/mKTapawcLQJjAJnBi7vunF/ChatGPT_Image_4_feb_2026,_08_10_38_a.m..png" alt="Bono 3 Kit Emergencia" className="w-full h-full object-cover" data-id="element-157" />
                <div className="absolute top-3 right-3 bg-red-600 text-white font-bold px-2 py-0.5 rounded shadow-lg transform rotate-3 text-xs" data-id="element-158">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-4" data-id="element-159">
                <p className="text-xs text-gray-500 line-through mb-0.5" data-id="element-160">
                  Valor: ARS $12.990
                </p>
                <p className="text-green-600 font-bold mb-2 text-sm" data-id="element-161">
                  HOY: GRATIS
                </p>
                <h3 className="text-lg font-bold mb-1" data-id="element-162">
                  🎁 Bono #3 – Kit de Emergencia Terapéutica
                </h3>
                <p className="text-gray-600 text-xs" data-id="element-163">
                  7 técnicas express + respiración + anclajes sensoriales +
                  frases seguras + qué NO decir en crisis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. TESTIMONIALS - Reduced spacing */}
      <section className="py-10 px-4 bg-gray-50" data-id="element-164">
        <div className="max-w-6xl mx-auto" data-id="element-165">
          <h2 className="text-2xl font-bold text-center mb-8 text-gray-900" data-id="element-166">
            Lo que dicen otros profesionales
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-167">
            <TestimonialCard name="Lic. Mariana Rossi" role="Psicóloga Clínica" location="Buenos Aires" content="Me dio la estructura que necesitaba. Antes perdía horas buscando recursos, ahora tengo todo organizado por objetivos. Mis pacientes notaron la diferencia en la calidad de las intervenciones." imageInitials="MR" data-id="element-168" />
            <TestimonialCard name="Carla Benítez" role="Arteterapeuta" location="Córdoba" content="Increíble la cantidad de técnicas. Lo que más valoro es el enfoque clínico, no son solo 'dibujitos', hay un propósito terapéutico claro en cada propuesta. El cuaderno creativo es una joya." imageInitials="CB" data-id="element-169" />
            <TestimonialCard name="Lic. Pablo Méndez" role="Psicólogo" location="Rosario" content="Al principio dudé por ser digital, pero la calidad es excelente. Los protocolos rápidos me salvaron en varias sesiones donde el paciente llegó muy bloqueado. Totalmente recomendado." imageInitials="PM" data-id="element-170" />
            <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4 md:w-2/3 mx-auto" data-id="element-171">
              <TestimonialCard name="Fernanda López" role="Coach Ontológico" location="Mendoza" content="Buscaba herramientas para trabajar emociones sin tanta palabra y esto fue perfecto. La baraja emocional es lo que más uso para abrir conversaciones difíciles." imageInitials="FL" data-id="element-172" />
              <TestimonialCard name="Julieta Soria" role="Acompañante Terapéutico" location="La Plata" content="Trabajo con adolescentes y a veces es difícil que se enganchen. Estas técnicas son dinámicas y atractivas. El kit de emergencia ya lo tengo impreso en mi mochila siempre." imageInitials="JS" data-id="element-173" />
            </div>
          </div>
        </div>
      </section>

      {/* 10. PRICING / OFFER - Fixed layout */}
      <section id="compra" className="py-12 px-4 bg-white" data-id="element-174">
        <div className="max-w-4xl mx-auto" data-id="element-175">
          <div className="border-4 border-dashed border-red-500 rounded-2xl p-4 md:p-8 bg-yellow-50 relative overflow-visible" data-id="element-176">
            {/* Fixed ribbon - positioned better */}
            <div className="absolute -top-3 -right-3 bg-red-600 text-white px-4 py-1.5 font-bold rounded shadow-lg text-xs z-10" data-id="element-177">
              🔥 OFERTA LIMITADA
            </div>

            <div className="text-center mb-6 pt-4" data-id="element-178">
              <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2" data-id="element-179">
                ⏰ Oferta por tiempo limitado
              </h2>
              <p className="text-lg text-gray-700" data-id="element-180">
                Accedé a MegaPack Arteterapia Clínica + los 3 bonos de regalo.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-inner mb-6" data-id="element-181">
              <h3 className="font-bold text-lg mb-4 border-b pb-2" data-id="element-182">
                📦 Lo que vas a recibir hoy:
              </h3>
              <ul className="space-y-2 mb-6" data-id="element-183">
                <li className="flex items-center font-bold text-gray-800" data-id="element-184">
                  <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-185" />
                  <span data-id="element-186">6 Tomos de Arteterapia Clínica</span>
                </li>
                <li className="flex items-center font-bold text-gray-800" data-id="element-187">
                  <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-188" />
                  <span data-id="element-189">Baraja Emocional Terapéutica (52 cartas)</span>
                </li>
                <li className="flex items-center font-bold text-gray-800" data-id="element-190">
                  <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-191" />
                  <span data-id="element-192">Cuaderno Creativo Terapéutico</span>
                </li>
                <li className="flex items-center font-bold text-blue-600 text-sm" data-id="element-193">
                  <span className="bg-blue-100 text-blue-600 text-xs px-2 py-0.5 rounded mr-2 flex-shrink-0" data-id="element-194">
                    BONO #1
                  </span>
                  <span className="whitespace-nowrap" data-id="element-195">
                    Workbook Clínico Profesional
                  </span>
                </li>
                <li className="flex items-center font-bold text-blue-600 text-sm" data-id="element-196">
                  <span className="bg-blue-100 text-blue-600 text-xs px-2 py-0.5 rounded mr-2 flex-shrink-0" data-id="element-197">
                    BONO #2
                  </span>
                  <span className="whitespace-nowrap" data-id="element-198">
                    Protocolos Clínicos Rápidos
                  </span>
                </li>
                <li className="flex items-center font-bold text-blue-600 text-sm" data-id="element-199">
                  <span className="bg-blue-100 text-blue-600 text-xs px-2 py-0.5 rounded mr-2 flex-shrink-0" data-id="element-200">
                    BONO #3
                  </span>
                  <span className="whitespace-nowrap" data-id="element-201">
                    Kit de Emergencia Terapéutica
                  </span>
                </li>
              </ul>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-600 bg-gray-100 py-2 px-3 rounded text-center" data-id="element-202">
                <span className="flex items-center" data-id="element-203">⚡ Acceso inmediato</span>
                <span className="flex items-center" data-id="element-204">📥 Descarga digital</span>
                <span className="flex items-center" data-id="element-205">♾️ Acceso de por vida</span>
              </div>
            </div>

            <div className="text-center" data-id="element-206">
              <div className="flex flex-col items-center justify-center mb-4" data-id="element-207">
                <span className="text-gray-500 text-lg line-through mb-1" data-id="element-208">
                  Precio regular: ARS $49.990
                </span>
                <div className="flex items-center justify-center gap-2" data-id="element-209">
                  <span className="text-red-600 font-bold text-lg animate-pulse whitespace-nowrap" data-id="element-210">
                    🔥 HOY SOLO:
                  </span>
                  <span className="text-4xl md:text-5xl font-extrabold text-green-600 whitespace-nowrap" data-id="element-211">
                    ARS $19.990
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap justify-center gap-3 mb-6 text-xs font-medium text-gray-700" data-id="element-212">
                <span className="flex items-center" data-id="element-213">
                  <Check className="w-3 h-3 text-green-500 mr-1" data-id="element-214" /> Un solo pago
                </span>
                <span className="flex items-center" data-id="element-215">
                  <Check className="w-3 h-3 text-green-500 mr-1" data-id="element-216" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center" data-id="element-217">
                  <Check className="w-3 h-3 text-green-500 mr-1" data-id="element-218" /> Descarga
                  digital
                </span>
                <span className="flex items-center" data-id="element-219">
                  <Check className="w-3 h-3 text-green-500 mr-1" data-id="element-220" /> Acceso de
                  por vida
                </span>
              </div>

              <a href={CHECKOUT_URL} className="block w-full py-5 text-xl md:text-2xl font-extrabold text-white bg-green-600 rounded-xl shadow-xl hover:bg-green-700 transform hover:-translate-y-1 transition-all duration-200 border-b-8 border-green-800 text-center" data-id="element-221">
                👉 OBTENER MI MEGAPACK HOY
              </a>
              <p className="mt-3 text-xs text-gray-500" data-id="element-222">
                Pago seguro y encriptado. Entrega inmediata por email.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 11. GUARANTEE - With centered shield badge */}
      <section className="py-10 px-4 bg-gray-50" data-id="element-223">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6" data-id="element-224">
          <div className="flex-shrink-0 relative" data-id="element-225">
            {/* Shield badge with centered text inside */}
            <div className="w-28 h-32 relative" data-id="element-226">
              <svg viewBox="0 0 100 120" className="w-full h-full" data-id="element-227">
                <path d="M50 5 L95 20 L95 60 C95 85 75 105 50 115 C25 105 5 85 5 60 L5 20 Z" fill="#facc15" stroke="#ca8a04" strokeWidth="3" data-id="element-228" />
                <path d="M50 15 L85 27 L85 58 C85 78 68 95 50 103 C32 95 15 78 15 58 L15 27 Z" fill="#fef08a" data-id="element-229" />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-230">
                <span className="text-2xl" data-id="element-231">🛡️</span>
                <span className="font-extrabold text-blue-900 text-xs leading-tight text-center" data-id="element-232">
                  GARANTÍA
                </span>
                <span className="font-bold text-blue-800 text-[10px] leading-tight text-center" data-id="element-233">
                  7 DÍAS
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-234">
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-235">
              🔒 Garantía sin riesgo
            </h3>
            <p className="text-gray-700 leading-relaxed text-sm" data-id="element-236">
              Probalo 7 días. Si no te aporta estructura, claridad y seguridad
              para intervenir, te devolvemos el 100% del dinero. Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* 12. FAQ - Reduced spacing */}
      <section className="py-10 px-4 bg-white" data-id="element-237">
        <div className="max-w-3xl mx-auto" data-id="element-238">
          <h2 className="text-2xl font-bold text-center mb-6 text-gray-900" data-id="element-239">
            ❓ Preguntas frecuentes
          </h2>
          <FAQ data-id="element-240" />
        </div>
      </section>

      {/* 13. FINAL CTA - Reduced spacing */}
      <section className="py-12 px-4 bg-gray-900 text-white text-center" data-id="element-241">
        <div className="max-w-3xl mx-auto" data-id="element-242">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-243">
            La arteterapia no debería improvisarse
          </h2>
          <p className="text-lg text-gray-300 mb-6" data-id="element-244">
            No necesitás más PDFs sueltos. Necesitás un sistema clínico listo
            para sostener sesiones reales.
          </p>
          <button onClick={scrollToCheckout} className="inline-block px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200" data-id="element-245">
            <span className="text-center" data-id="element-246">
              👉 Accedé ahora al MegaPack Arteterapia Clínica
            </span>
          </button>
        </div>
      </section>

      <footer className="py-6 bg-black text-gray-500 text-center text-xs" data-id="element-247">
        <p data-id="element-248">
          © 2026 MegaPack Arteterapia Clínica. Todos los derechos reservados.
        </p>
        <p className="mt-1" data-id="element-249">
          Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}
function XIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-250">
      <path d="M18 6 6 18" data-id="element-251" />
      <path d="m6 6 12 12" data-id="element-252" />
    </svg>;
}